import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconDragHandleAltStyle0 = gravityIconIndividualCss;

const GravityIconDragHandleAlt = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '985c5e78333f7b43a18900e0c2c8bd2a99ef1073', color: this.color, size: this.size }, h("svg", { key: '30f11647b7268dc091718c99dc26c90702c1baf3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '8fd5de78c5f4da624646033c160c84c4ec2f84c3', d: "M8.173 6.667a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667ZM6.84 11a1.333 1.333 0 1 0 2.667 0 1.333 1.333 0 0 0-2.667 0Zm5.667 0a1.333 1.333 0 1 0 2.666 0 1.333 1.333 0 0 0-2.666 0Zm0-5.667a1.333 1.333 0 1 0 2.666 0 1.333 1.333 0 0 0-2.666 0ZM13.84 18a1.333 1.333 0 1 1 0-2.666 1.333 1.333 0 0 1 0 2.666Zm-7-1.333a1.333 1.333 0 1 0 2.667 0 1.333 1.333 0 0 0-2.667 0Z", fill: "currentColor" }))));
    }
};
GravityIconDragHandleAlt.style = GravityIconDragHandleAltStyle0;

export { GravityIconDragHandleAlt as gravity_icon_drag_handle_alt };

//# sourceMappingURL=gravity-icon-drag-handle-alt.entry.js.map